import { createFileRoute } from '@tanstack/react-router'
import { SiteContextMonitoringPage } from 'pages/siteContextMonitoring/SiteContextMonitoringPage'
import { siteContextMonitoringSearchParams } from 'routes/site-context-monitoring/-searchParams'

const RouteComponent = () => {
  const { siteId, mode, sentinelId, designContextId } = Route.useSearch()
  return (
    <SiteContextMonitoringPage
      siteId={siteId ?? null}
      monitoring={mode ? { mode, sentinelId, designContextId } : undefined}
    />
  )
}

export const Route = createFileRoute('/site-context-monitoring/')({
  component: RouteComponent,
  validateSearch: siteContextMonitoringSearchParams,
  staticData: {
    title: 'Site Context & Monitoring',
  },
})
